'use client';

import type { MacaronRenderContext, RecordAny } from '@macaron-a2ui/core/v0_8';

export function MacaronBooleanAnyOf({ config: _config, ctx: _ctx }: { config: RecordAny; ctx: MacaronRenderContext }) {
  // Logic-only support widgets are evaluated from the shared canvas renderer state graph.
  return null;
}
